import { render, staticRenderFns } from "./pois.vue?vue&type=template&id=d251af48&scoped=true"
import script from "./pois.vue?vue&type=script&lang=js"
export * from "./pois.vue?vue&type=script&lang=js"
import style0 from "./pois.vue?vue&type=style&index=0&id=d251af48&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d251af48",
  null
  
)

export default component.exports